import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

export default function PageHero({ eyebrow, title, subtitle, image }) {
  const ref = useRef(null);
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 600], [0, 100]);

  return (
    <section
      ref={ref}
      data-testid="page-hero"
      className="relative min-h-[70vh] flex items-end overflow-hidden grain"
    >
      <motion.div style={{ y }} className="absolute inset-0 z-0">
        <img
          src={image}
          alt={title}
          className="w-full h-[120%] object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-black/60 to-black/40" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/30 to-transparent" />
      </motion.div>

      <div className="relative z-10 max-w-7xl mx-auto w-full px-6 md:px-10 pt-40 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 30, filter: "blur(8px)" }}
          animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          transition={{ duration: 1 }}
          className="max-w-3xl"
        >
          <div className="flex items-center gap-4 mb-6">
            <span className="divider-gold" />
            <span className="text-[11px] tracking-[0.4em] uppercase text-[#D4AF37] font-medium">
              {eyebrow}
            </span>
          </div>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-white font-light leading-[1.0]">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 text-lg md:text-xl text-white/65 font-light leading-relaxed max-w-2xl">
              {subtitle}
            </p>
          )}
        </motion.div>
      </div>
    </section>
  );
}
